import {
    required,
    TextInput,
    useDataProvider,
    useNotify,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { SimpleFormWithPermissions } from "../components/SimpleFormWithPermissions";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaEditView } from "../components/views/RaEditView";
import { AddressFormInput } from "../components/AddressFormInput";
import { transformDataAndUpdateAddress } from "../utils/transformDataAndUpdateAddress";
import { handleHttpError } from "shared/src/utils/errorHandler";

export const ManufacturerEdit = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaEditView
            mutationMode="pessimistic"
            actions={<ToolbarWithHistory back={true} show={true} />}
            transform={(data) =>
                transformDataAndUpdateAddress(data, dataProvider, (e) =>
                    handleHttpError(e, notify)
                )
            }
            {...props}
        >
            <SimpleFormWithPermissions>
                <TextInput
                    label="equip.name"
                    title={translate("equip.name")}
                    source="name"
                    validate={[required()]}
                />
                <AddressFormInput />
            </SimpleFormWithPermissions>
        </RaEditView>
    );
};
